import React, { useEffect, useState } from 'react';
import './RecipientsMourners.scss';
import { useSelector } from 'react-redux';
import MournerItem from './MournerItem';
const RecipientsMourners = ({ values, setFieldValue }) => {
  // const [selectedRicipient, setSelectedRicipient] = useState(values?.recipients || []);
  // console.log('selectRicipient: ', selectedRicipient);
  console.log('values: ', values);

  const { selectedDeceased } = useSelector((state) => state.CommonStates);
  let selectedMourners = [];
  const mourners = selectedDeceased?.map((dec) => {
    return dec?.mourners_list?.forEach((item) => {
      selectedMourners.push({
        ...item,
        name: dec?.name,
        'hebrew name of Death': dec?.hebrew_name_of_Death,
        'hebrew date of death': dec?.hebrew_date_of_death,
        'mother name': dec?.mother_name,
        'date of death': dec?.date_of_death,
        gender: dec?.gender,
        'about the deceased': dec?.about_the_deceased,
        cemetery: dec?.cemetery,
        'plaque number': dec?.plaque_number,
        deceasedId: dec?._id,
      });
      return item;
    });
  });

  // filter mourner with email & remove duplicate mourner
  const mournerWithEmailWithoutDuplicate = selectedMourners
  ?.filter((item) => item?.member_id?.email_address || item?.email)
  ?.filter(
    (item, index, self) =>
    index ===
    self.findIndex((item2) => item2?.member_id?._id === item?.member_id?._id || item2?.email === item?.email) // item?.email for non member so the member exist in member_id object
    );

  const mournerWithEmail = selectedMourners?.filter(
    (item) => item?.member_id?.email_address || item?.email
    );

  useEffect(() => {
    if (!values?.recipients) {
      // setSelectedRicipient(mournerWithEmail);
      setFieldValue('recipients', mournerWithEmail);
    }
    if(!values?.mournerWithEmailWithoutDuplicate){
      setFieldValue('mournerWithEmailWithoutDuplicate', mournerWithEmailWithoutDuplicate);
    }
  }, []);

  return (
    <div className="recipients">
      <div className="recipients__title">
        <h3> Recipients </h3>
        <h3>{values?.mournerWithEmailWithoutDuplicate?.length}</h3>
      </div>
      <div className="listText">
        The following is a list of the {values?.mournerWithEmailWithoutDuplicate?.length} recipients.
      </div>
      <hr />
      <div className="mourner_list">
        {mournerWithEmailWithoutDuplicate?.map((item) => (
          <MournerItem
            key={item?._id}
            id={item?._id}
            item={item}
            profile_img={item?.member_id?.profile_img}
            email={item?.member_id?.email_address || item?.email}
            full_name={item?.member_id?.full_name}
            first_name={item?.member_id?.first_name}
            last_name={item?.member_id?.last_name}
            // selectedRicipient={selectedRicipient}
            // setSelectedRicipient={setSelectedRicipient}
            values={values}
            setFieldValue={setFieldValue}
            selectedMourners={selectedMourners}
          />
        ))}
      </div>
    </div>
  );
};

export default RecipientsMourners;
